import { Card } from "@omni/ui/components/Card/card";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { useStoreFeaturesContext } from "@/components/Store/StoreFeatures/context/storeFeatures.context";

const Item = () => {
    const { storeFeatures } = useStoreFeaturesContext();
    const { index } = useMapped();

    const storeFeature = storeFeatures.at(index);

    if (!storeFeature) {
        return null;
    }

    return (
        <Col
            lg={2}
            md={3}
            sm={4}
            xs={6}
            className={cn("tw:mb-6")}
        >
            <Card
                tag="a"
                href={storeFeature.url}
                className={cn("tw:hover:underline tw:h-full")}
            >
                <Card.Image
                    src={storeFeature.imageUrl}
                    alt={storeFeature.imageAltText || storeFeature.title}
                    className={cn("tw:aspect-video")}
                />
                <Card.Body>
                    <Card.Title tag="h5">{storeFeature.title}</Card.Title>
                    <Card.Text
                        className={cn("tw:text-sm")}
                        dangerouslySetInnerHTML={{
                            __html: storeFeature.description
                        }}
                    />
                </Card.Body>
            </Card>
        </Col>
    );
};

export { Item };
